import React from 'react';

const Loading = ({ fullPage = false }) => {
  if (fullPage) {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
        }}
      >
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <div className="loading">
      <div className="spinner"></div>
    </div>
  );
};

export default Loading;
